import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 特定商取引法に基づく表記 支払い時期
 */
export class SctActPaymentTerm extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): SctActPaymentTerm {
    return new SctActPaymentTerm(value);
  }
}
